// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fp-loader {
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 40px 20px;
}

.fp-loader-mark {
  width: 54px;
  height: 54px;
  object-fit: contain;
  animation: fp-pulse 1.4s ease-in-out infinite;
}

.fp-loader-bar {
  position: relative;
  width: 180px;
  height: 4px;
  border-radius: var(--radius-pill);
  background: var(--brand-100);
  overflow: hidden;
}

.fp-loader-bar span {
  position: absolute;
  inset: 0 auto 0 0;
  width: 40%;
  border-radius: var(--radius-pill);
  background: var(--grad-brand);
  animation: fp-slide 1.2s ease-in-out infinite;
}

.fp-loader p {
  font-size: 0.9rem;
  color: var(--muted);
}

@keyframes fp-pulse {
  0%,
  100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.92);
    opacity: 0.65;
  }
}

@keyframes fp-slide {
  0% {
    left: -40%;
  }
  100% {
    left: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .fp-loader-mark,
  .fp-loader-bar span {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/FullPageLoader.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,iCAAiC;EACjC,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".fp-loader {\n  min-height: 60vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  padding: 40px 20px;\n}\n\n.fp-loader-mark {\n  width: 54px;\n  height: 54px;\n  object-fit: contain;\n  animation: fp-pulse 1.4s ease-in-out infinite;\n}\n\n.fp-loader-bar {\n  position: relative;\n  width: 180px;\n  height: 4px;\n  border-radius: var(--radius-pill);\n  background: var(--brand-100);\n  overflow: hidden;\n}\n\n.fp-loader-bar span {\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 40%;\n  border-radius: var(--radius-pill);\n  background: var(--grad-brand);\n  animation: fp-slide 1.2s ease-in-out infinite;\n}\n\n.fp-loader p {\n  font-size: 0.9rem;\n  color: var(--muted);\n}\n\n@keyframes fp-pulse {\n  0%,\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(0.92);\n    opacity: 0.65;\n  }\n}\n\n@keyframes fp-slide {\n  0% {\n    left: -40%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fp-loader-mark,\n  .fp-loader-bar span {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
